import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "details-panel" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PxGrid = _resolveComponent("PxGrid")!
  const _component_ResultsReport = _resolveComponent("ResultsReport")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PxPanel, {
          key: 0,
          title: _ctx.$t('selfAssessment.results.detailsPanel.title'),
          class: "px-panel--mobile-no-side-borders"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_PxGrid, {
              categories: _ctx.categories,
              "current-level": _ctx.finalLevel.value,
              levels: _ctx.numOfLevels,
              results: _ctx.results,
              size: _ctx.gridSize,
              class: "details-panel__grid"
            }, null, 8, ["categories", "current-level", "levels", "results", "size"]),
            _cache[0] || (_cache[0] = _createElementVNode("hr", null, null, -1)),
            _createVNode(_component_ResultsReport, {
              categories: _ctx.categories,
              levels: _ctx.results
            }, null, 8, ["categories", "levels"])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ]))
}